import {
  BOARDS_MENU_TOOLTIP_DATE_END,
  BOARDS_MENU_TOOLTIP_LOCAL_STORAGE_KEY,
} from '@/features/Boards/constants';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useBoardsMenuTooltip = (
  { dateEnd = BOARDS_MENU_TOOLTIP_DATE_END }: { dateEnd?: string } = {
    dateEnd: BOARDS_MENU_TOOLTIP_DATE_END,
  }
) => {
  const [show, setShow] = useState(false);

  const isTwoMonthsAfterRelease = useMemo(() => {
    const today = new Date().toISOString();
    const result = today.localeCompare(dateEnd); // -1 before limit, 0 exactly as limit, 1 after limit

    if (result === 1) {
      // 2 months have passed after release date
      return true;
    }

    // today is less or exactly 2 months after release, i.e., result is either -1 or 0
    return false;
  }, [dateEnd]);

  const checkUserHasSeenTooltip = useCallback(() => {
    if (typeof localStorage === 'undefined') {
      return false;
    }

    const data = localStorage.getItem(BOARDS_MENU_TOOLTIP_LOCAL_STORAGE_KEY);

    if (!data || data === 'false') {
      return false;
    }

    return true;
  }, []);

  const revalidate = useCallback(() => {
    const userHasSeenTooltip = checkUserHasSeenTooltip();

    if (isTwoMonthsAfterRelease || userHasSeenTooltip) {
      setShow(false);
      return;
    }

    setShow(true);
  }, [isTwoMonthsAfterRelease, checkUserHasSeenTooltip]);

  const dismiss = useCallback(() => {
    localStorage.setItem(BOARDS_MENU_TOOLTIP_LOCAL_STORAGE_KEY, 'true');
    revalidate();
  }, [revalidate]);

  useEffect(() => {
    revalidate();
  }, [revalidate]);

  return { show, revalidate, dismiss };
};
